import { AmountDisplayType } from '@/entity/amountDisplayType';
import { PointUseType } from '@/entity/pointUseType';
import { createContext } from '@berlin-front/common/composables/context';
import { UnwrapRef } from '@vue/composition-api';

export type OneTimePaymentContextType = {
  useOneTimePayment: () => UnwrapRef<{
    alert: string[];
    state: {
      // 入力利用ポイント数
      point: number | '';
    };
    // ポイント表示種別（enable: 表示, disable: 非表示）
    pointUseType: PointUseType;
    // 金額表示種別（normal: 通常, unsettled: 未確定, hide:非表示）
    amountDisplayType: AmountDisplayType;
    // 保有ポイント数
    retentionPoint: number;
    // 利用ポイント数（利用上限ポイントを超えないようにする）
    subtractPoint: string;
    // 商品合計金額
    itemTotalPrice: number;
    // 合計金額（商品合計金額 - 利用ポイント数）
    totalAmount: number;
    // ポイントを持っているか
    hasPoint: boolean;
    // ポイントシステムでエラーが発生している
    npcSystemHasError: boolean;
    // 分割払いが利用できない場合に表示するメッセージ
    splitMessages: string[];
    // ユーザ名（フッターにユーザ名と「ログアウト」ボタンを表示する）
    memberName: string;
    // 利用ポイント入力からフォーカスを外した時のアクション
    onBlur: () => void;
    // 利用ポイント入力時のアクション
    onInput: (value: string) => void;
    // 「ご注文を確定」押下時のアクション
    onSubmit: () => void;
    // 「戻る」押下時のアクション
    goBack: (() => void) | undefined;
  }>;
};

export const OneTimePaymentContext = createContext<OneTimePaymentContextType>({} as OneTimePaymentContextType);
